import { __extends } from "tslib";
var KvikaApiError = (function (_super) {
    __extends(KvikaApiError, _super);
    function KvikaApiError(message, error) {
        var _this = _super.call(this, message) || this;
        _this.config = error.config;
        _this.code = error.code;
        _this.request = error.request;
        _this.response = error.response;
        _this.isAxiosError = error.isAxiosError;
        _this.toJSON = error.toJSON;
        return _this;
    }
    return KvikaApiError;
}(Error));
export default KvikaApiError;
//# sourceMappingURL=ApiError.js.map